import { put, takeEvery } from 'redux-saga/effects';
import { getFile } from './api';
import { PROXY_IMAGE } from './constants';
import { loadProxySuccess } from './actions';

/**
 *
 * @param obj
 * @returns {IterableIterator<Promise<Response|never>|PutEffect<{result: *, type: string}>>}
 */
function* imgProxy( obj ) {
    const serverResponse = yield getFile( obj.form, obj.resolve );
    if ( serverResponse ) {
        yield put( loadProxySuccess( serverResponse ) );
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchProxyImage() {
    yield takeEvery( PROXY_IMAGE, imgProxy );
}

export default watchProxyImage;
